import { createSelector } from 'reselect';

const getNetworkReducer = state => state.network;

/**
 * @function selectNetwork
 * @returns {import('./reducer').Network}
 */
export const selectNetwork = createSelector(
  [getNetworkReducer],
  ({ network }) => network,
);

/**
 * @function selectNetworkId
 * @returns {string}
 */
export const selectNetworkId = createSelector(
  [selectNetwork],
  ({ id }) => id,
);

/**
 * @function selectRolloutDate
 * @returns {string}
 */
export const selectRolloutDate = createSelector(
  [selectNetwork],
  ({ rolloutDate }) => rolloutDate,
);

/**
 * @function selectIsLegacyBusinessModel
 * @returns {boolean}
 */
export const selectIsLegacyBusinessModel = createSelector(
  [selectRolloutDate],
  rolloutDate => new Date() < new Date(rolloutDate),
);

/**
 * @function selectIsNewBusinessModel
 * @returns {boolean}
 */
export const selectIsNewBusinessModel = createSelector(
  [selectRolloutDate],
  rolloutDate => new Date() >= new Date(rolloutDate),
);

/**
 * @returns {'ALL'|'NO_LEADS'|'EMAIL'|'PHONE'}
 */
export const selectLeadPlan = createSelector(
  [selectNetwork],
  ({ leadPlan }) => leadPlan,
);
